import script from "./MessageInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageInput.vue?vue&type=script&setup=true&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=3a97724c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a97724c"]])

export default __exports__